import { useMutation } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCall";

export const useSendChatMessage = () => {
  return useMutation({
    mutationFn: ({ message, threadId, userContext, currentPage }) =>
      callApi({
        method: "POST",
        url: "chat",
        data: { message, threadId, userContext, currentPage },
      }),
  });
};
